"use strict";

import _classCallCheck from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { UrlJsonRpcProvider } from "./url-json-rpc-provider";
import { Logger } from "@ethersproject/logger";
import { version } from "./_version";
var logger = new Logger(version);
export var CloudflareProvider = /*#__PURE__*/function (_UrlJsonRpcProvider) {
  _inherits(CloudflareProvider, _UrlJsonRpcProvider);

  var _super2 = _createSuper(CloudflareProvider);

  function CloudflareProvider() {
    _classCallCheck(this, CloudflareProvider);

    return _super2.apply(this, arguments);
  }

  _createClass(CloudflareProvider, [{
    key: "perform",
    value: function perform(method, params) {
      var _this = this;

      var _super = Object.create(null, {
        perform: {
          get: function get() {
            return _get(_getPrototypeOf(CloudflareProvider.prototype), "perform", _this);
          }
        }
      });

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var block;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(method === "getBlockNumber")) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return _super.perform.call(this, "getBlock", {
                  blockTag: "latest"
                });

              case 3:
                block = _context.sent;
                return _context.abrupt("return", block.number);

              case 5:
                return _context.abrupt("return", _super.perform.call(this, method, params));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }], [{
    key: "getApiKey",
    value: function getApiKey(apiKey) {
      if (apiKey != null) {
        logger.throwArgumentError("apiKey not supported for cloudflare", "apiKey", apiKey);
      }

      return null;
    }
  }, {
    key: "getUrl",
    value: function getUrl(network, apiKey) {
      var host = null;

      switch (network.name) {
        case "homestead":
          host = "https://cloudflare-eth.com/";
          break;

        default:
          logger.throwArgumentError("unsupported network", "network", arguments[0]);
      }

      return host;
    }
  }]);

  return CloudflareProvider;
}(UrlJsonRpcProvider);